import { Box, type BoxProps } from "@mui/material";

interface LogoContainerProps extends BoxProps {
  children: React.ReactNode;
}

export function LogoContainer({ children, ...props }: LogoContainerProps) {
  return (
    <Box
      sx={{
        margin: "0 20px",
        lineHeight: 0,
        float: "left",
        minWidth: "fit-content",
        "& .logo": {
          display: "inline-block",
        },
        "@media (max-width: 992px)": {
          display: "block",
          textAlign: "center",
          margin: 0,
          float: "none",
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
